import React from "react";
import './LoaderDots.css';
import { Logo1 } from "../../Assests/Assests";

const Loaderdots = () => {
  return (
    <div className="riy-loader-screen">
      <div className="riy-loader-scene">
        <div className="riy-loader-glow" />
        <div className="riy-loader-ring riy-ring-1" />
        <div className="riy-loader-ring riy-ring-2" />
        <div className="riy-loader-logo">
          <img src={Logo1} alt="Riymay" />
        </div>
      </div>
    </div>
  );
};

export default Loaderdots;
